import React from "react";
import { Link } from "react-router-dom";

export default function PublicMainFooter() {
  const navStyle = "text-blue-700 hover:text-blue-800 mr-6";

  return (
    <div className="bg-white border-t border-t-gray-400 p-6 rounded flex w-full">
      <nav className="flex-1 p-4 mx-2">
        <h3 className="font-bold">Quick Links</h3>
        <div>
          <li>
            <Link className={navStyle} to="/">
              Home
            </Link>
          </li>
          <li>
            <Link className={navStyle} to="/about">
              About
            </Link>
          </li>
          <li>
            <Link className={navStyle} to="/blog">
              Blog
            </Link>
          </li>
          <li>
            <Link className={navStyle} to="/pricing">
              Pricing
            </Link>
          </li>
          <li>
            <Link className={navStyle} to="/reviews ">
              Reviews{" "}
            </Link>
          </li>
        </div>
      </nav>
      <nav className="flex-1 p-4 mx-2">
        <h3 className="font-bold">Get Online</h3>
        <div>
          <li>
            <Link className={navStyle} to="/login">
              Login
            </Link>
          </li>
          <li>
            <Link className={navStyle} to="/signup">
              Signup
            </Link>
          </li>
        </div>
      </nav>
      <nav className="flex-1 p-4 mx-2">
        <h3 className="font-bold">Get Support</h3>
        <div>
          <li>
            <Link className={navStyle} to="/customer-support">
              Customer Support
            </Link>
          </li>
          <li>
            <Link className={navStyle} to="/live-chat">
              Live Chat
            </Link>
          </li>
        </div>
      </nav>
      <nav className="flex-1 p-4 mx-2">
        <h3 className="font-bold">Get Involved</h3>
        <div>
          <li>
            <Link className={navStyle} to="/community">
              Community
            </Link>
          </li>
          <li>
            <Link className={navStyle} to="/community/@facebook">
              Facebook Community
            </Link>
          </li>
          <li>
            <Link className={navStyle} to="/community/@linkedin">
              Linkedin Community
            </Link>
          </li>
          <li>
            <Link className={navStyle} to="/community/@discord">
              Discord Community
            </Link>
          </li>
        </div>
      </nav>
      <nav className="flex-1 p-4 mx-2">
        <h3 className="font-bold">Get Info</h3>
        <div>
          <li>
            <Link className={navStyle} to="/legal">
              Legal
            </Link>
          </li>
          <li>
            <Link className={navStyle} to="/roadmap">
              Product Roadmap
            </Link>
          </li>
          <li>
            <Link className={navStyle} to="/suggest-feature">
              Suggest Feature
            </Link>
          </li>
        </div>
      </nav>
    </div>
  );
}
